import React, { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { CollectionUUID } from '@library/menu-service'

import { actionTypes } from 'actions/actionTypes'
import { clickMerchandisingBanner } from 'actions/trackingKeys'
import { useSelectCollection } from 'hooks/menu-collections'
import { WaveLinkHeaderProps } from 'routes/Menu/MenuRecipesPage/CollectionHeader/WaveLinkHeader/WaveLinkHeader'
import { MenuHeadersIncludesData } from 'routes/Menu/domains/brand/types'

import { WaveLinkHeader } from '../WaveLinkHeader'

type OwnProps = {
  link: MenuHeadersIncludesData['attributes']['link']
}

const useChangeCollectionById = (collectionId: CollectionUUID) => {
  const selectCollection = useSelectCollection()
  const dispatch = useDispatch()

  return useCallback(() => {
    if (collectionId) {
      selectCollection(collectionId, (oldCollection, newCollection) => {
        if (newCollection && oldCollection?.id !== newCollection?.id) {
          // this action doesn't have a reducer, but tracking data is passed to snowplow v1 tracker
          dispatch({
            type: actionTypes.FILTERS_COLLECTION_CHANGE,
            collectionName: newCollection.slug,
            collectionId: newCollection.id,
            trackingData: {
              actionType: actionTypes.RECIPE_COLLECTION_SELECTED,
              collectionId: newCollection.id,
            },
          })

          dispatch({
            type: actionTypes.TRACKING,
            trackingData: {
              actionType: clickMerchandisingBanner,
              collection_id: newCollection.id,
              click_collection_id: oldCollection?.id || null,
            },
          })
        }
      })
    }
  }, [collectionId, dispatch, selectCollection])
}

const WaveLinkHeaderContainer = (props: Omit<OwnProps & WaveLinkHeaderProps, 'onClick'>) => {
  const { link } = props
  const collectionId = (link?.collectionId || '') as CollectionUUID

  const changeCollectionById = useChangeCollectionById(collectionId)

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <WaveLinkHeader {...props} onClick={changeCollectionById} />
}

export { WaveLinkHeaderContainer }
